// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@abb-motion-ux/commonux-web-components/dist/commonux-web-components/commonux-web-components.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🎨 Import Centralized Design Token System */
/* @import 'centralized-token-system/src/commonUX-designToken.css'; */

/* ABB Zelda Global Styles - Using Centralized Tokens Only */
body {
  font-family: var(--abb-font-family, 'ABBvoice', 'Segoe UI', Arial, sans-serif);
  color: var(--global-grey-800);
  background: var(--global-white-secondary);
  margin: 0;
  padding: 0;
  line-height: 1.5;
}

/* ─── Print: hide everything except Results page ─── */
@media print {
  body * {
    visibility: hidden;
  }
  [data-print-area],
  [data-print-area] * {
    visibility: visible !important;
  }
  [data-print-area] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  @page {
    size: A4 landscape;
    margin: 10mm;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C,qEAAqE;;AAGrE,4DAA4D;AAC5D;EACE,8EAA8E;EAC9E,6BAA6B;EAC7B,yCAAyC;EACzC,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA,uDAAuD;AACvD;EACE;IACE,kBAAkB;EACpB;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,YAAY;EACd;AACF","sourcesContent":["/* 🎨 Import Centralized Design Token System */\n/* @import 'centralized-token-system/src/commonUX-designToken.css'; */\n@import \"~@abb-motion-ux/commonux-web-components/dist/commonux-web-components/commonux-web-components.css\";\n\n/* ABB Zelda Global Styles - Using Centralized Tokens Only */\nbody {\n  font-family: var(--abb-font-family, 'ABBvoice', 'Segoe UI', Arial, sans-serif);\n  color: var(--global-grey-800);\n  background: var(--global-white-secondary);\n  margin: 0;\n  padding: 0;\n  line-height: 1.5;\n}\n\n/* ─── Print: hide everything except Results page ─── */\n@media print {\n  body * {\n    visibility: hidden;\n  }\n  [data-print-area],\n  [data-print-area] * {\n    visibility: visible !important;\n  }\n  [data-print-area] {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n  }\n  @page {\n    size: A4 landscape;\n    margin: 10mm;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
